import React from "react"
import IconTrade from "@/assets/images/scheme/icon-trade.png";
import OverPack from "rc-scroll-anim/lib/ScrollOverPack";
import QueueAnim from "rc-queue-anim";
import Bg01 from "@/assets/images/product/construction/ec-bg01.jpg";
import Bg02 from "@/assets/images/product/construction/ec-bg02.jpg";
import Bg03 from "@/assets/images/product/construction/ec-bg03.jpg";
import Bg04 from "@/assets/images/product/construction/ec-bg04.jpg";
import Bg05 from "@/assets/images/product/construction/ec-bg05.jpg";
import Bg06 from "@/assets/images/product/construction/ec-bg06.jpg";
import Bg07 from "@/assets/images/product/construction/ec-bg07.jpg";
import Bg08 from "@/assets/images/product/construction/ec-bg08.jpg";
import Bg09 from "@/assets/images/product/construction/ec-bg09.jpg";
import Bg10 from "@/assets/images/product/construction/ec-bg10.jpg";
import Bg11 from "@/assets/images/product/construction/ec-bg11.jpg";
import Bg12 from "@/assets/images/product/construction/ec-bg12.jpg";
import Bg13 from "@/assets/images/product/construction/m-bg04.jpg";

const EchelonList = () => {
  return (
    <div className='warp-visit wrap-bank-list' style={{minHeight: '11000px', backgroundColor: '#FFFFFF'}}>
      <div className='wrap-bank-list-header'>
        <div className='home-page'>
          <div className='wrap-bank-list-header-box'>
            <img src={IconTrade} alt=""/>
            <div className='wrap-title'>人才梯队赋能：精准测培，驱动组织进化</div>
          </div>
          <div className='wrap-desc'>精准刻画人群画像，打造贯穿组织全生命周期的阶梯式培养体系</div>
        </div>
      </div>
      <div className='wrap-bank-list-summary'>
        <div className='home-page'>
          <div className='warp-visit-content-items'>
            <div className='content-item' style={{padding: '0px'}}>
              <div className='content-item-block' style={{marginTop: '0px'}}>
                <div className='b-content p-pre-wrap'>
                  在AI技术全面爆发与数字化转型的交汇点，商业生态与组织边界正经历底层重构。智能化工具的普及，不仅在职场中催生出具备指数级效能的超级个体，更对企业的人才密度提出了颠覆性要求。面向存量博弈的未来，企业不仅迫切渴求跨界融合、懂技术更懂业务的复合型人才，更急需一批能够驾驭不确定性、引领业务破局的经营管理人才。面对这一时代命题，熙诚教育全面重构梯队赋能逻辑。我们告别千人一面的传统培训，以大数据人才盘点与能力画像为起点。紧扣企业关键战役与真实业务场景，打造贯穿领军高管、中坚力量到高潜新锐的分层分类测培体系。通过精准靶向赋能，让个体潜能的觉醒与组织进化的步伐同频共振，构筑新质生产力时代的核心人才引擎。
                </div>
              </div>
            </div>
          </div>
          <div className='warp-visit-content-items'>
            <div className='content-item' style={{padding: '0px', marginTop: '60px'}}>
              <div className='content-item-block'>
                <div className='b-title'>
                  为什么传统的梯队培养总是“收效甚微”？ 熙诚教育重构人才赋能的三大底层逻辑：
                </div>
                <div className='wrap-b-desc'>
                  <div className='b-desc'>
                    <div className='dot'></div>
                    <div className='text'>
                      选筛精准化——从“经验选人”走向“数据识人”
                    </div>
                  </div>
                  <div className='b-desc'>
                    <div className='text'>
                      告别单一维度的主观评价，基于岗位胜任力模型与多维度测评工具，对候选人的能力素质、行为特质、价值观取向进行科学评估与系统校准。通过筛选工具实现精准落位，确保选人有依据、筛人有标准，让真正的高潜人才从组织中浮现出来。
                    </div>
                  </div>
                  <div className='b-desc'>
                    <div className='dot'></div>
                    <div className='text'>
                      内容靶向化——从“大水漫灌”转向“精准滴灌”
                    </div>
                  </div>
                  <div className='b-desc'>
                    <div className='text'>
                      紧贴企业战略落地的关键战役与经营管理中的真实痛点，摒弃脱离业务的理论灌输。项目及内容设计以解决实际问题为导向，融合多元形式，构建“训前精准诊断—训中实战淬炼”的靶向赋能闭环，确保每一分培训投入都指向能力的真实提升。
                    </div>
                  </div>
                  <div className='b-desc'>
                    <div className='dot'></div>
                    <div className='text'>
                      发展长效化——从“一训了之”升级为“全周期管理”
                    </div>
                  </div>
                  <div className='b-desc'>
                    <div className='text'>
                      将人才培养视为贯穿“选-育-用-留”全链条的系统工程，而非一次性的培训活动。打造“课前测评—课中实战—课后追踪—行动复盘”的可视化成长证据链，建立“一人一档”全周期成长档案。通过持续追踪与动态评估，让培养效果可量化、可追溯、可迭代，真正实现从“培训结束”到“成长开始”的管理闭环。
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <OverPack playScale={0.3}>
            <QueueAnim
              key="text"
              type="bottom"
              leaveReverse
              ease={['easeOutQuad', 'easeInQuad']}
              style={{minHeight: '549px', marginTop: '40px'}}
            >
              <div className='warp-visit-content-items' key='name'>
                <div className='content-item' style={{padding: '0px', marginTop: '60px'}}>
                  <div className='content-item-block'>
                    <div className='b-title'>
                      从战略到一线的人才系统工程
                    </div>
                  </div>
                </div>
              </div>
              <img src={Bg01} alt="" width='1200px' key='img' />
            </QueueAnim>
          </OverPack>
          <OverPack playScale={0.3}>
            <QueueAnim
              key="text"
              type="bottom"
              leaveReverse
              ease={['easeOutQuad', 'easeInQuad']}
              style={{minHeight: '850px', marginTop: '60px'}}
            >
              <div className='warp-visit-content-items' key='name'>
                <div className='content-item' style={{padding: '0px', marginTop: '60px'}}>
                  <div className='content-item-block'>
                    <div className='b-title'>
                      人才梯队 | 领军人才 |《驭势·增长破局计划》
                    </div>
                  </div>
                </div>
              </div>
              <div className='desc' style={{margin: '24px 0'}}  key='desc'>
                企业跨越增长瓶颈，从来不是单一维度的突破——它需要战略方向的精准锚定、增长引擎的系统构建、治理体系的扎实支撑，更需要核心决策层认知的同频升级。当企业从“老板驱动”走向“系统驱动”，从“机会增长”走向“战略增长”，决策层需要一套完整的破局逻辑：既要在不确定中动态调整战略锚点，又要让增长方法论与治理体系形成共振。我们聚焦增长战略、资本思维、治理体系与核心团队同频四大维度，帮助企业决策层打通“增长”与“治理”的协同逻辑——让企业不仅跑得快，更能跑得稳、跑得远。
              </div>
              <img src={Bg02} alt="" width='1200px' key='img' />
            </QueueAnim>
          </OverPack>
          <OverPack playScale={0.3}>
            <QueueAnim
              key="text"
              type="bottom"
              leaveReverse
              ease={['easeOutQuad', 'easeInQuad']}
              style={{minHeight: '850px', marginTop: '60px'}}
            >
              <div className='warp-visit-content-items' key='name'>
                <div className='content-item' style={{padding: '0px', marginTop: '60px'}}>
                  <div className='content-item-block'>
                    <div className='b-title'>
                      人才梯队 | 高层领导 | 《跃领·战略经营突破计划》
                    </div>
                  </div>
                </div>
              </div>
              <div className='desc' style={{margin: '24px 0'}}  key='desc'>
                当外部环境剧变、政策逻辑调整、技术曲线加速，高管的决策质量直接决定了组织的生死与走向。而大多数高管今天的困境在于：用过去十年积累的经验，应对未来十年从未见过的问题。我们聚焦宏观视野、战略决断、经营破局、组织变革与领导力进化五大维度，帮助高管在复杂商业环境中建立系统性的战略思维框架，将经验直觉升级为可复用的决策方法论——让每一次战略判断都有据可依，让每一次组织调整都指向增长。
              </div>
              <img src={Bg03} alt="" width='1200px' key='img' />
            </QueueAnim>
          </OverPack>
          <OverPack playScale={0.3}>
            <QueueAnim
              key="text"
              type="bottom"
              leaveReverse
              ease={['easeOutQuad', 'easeInQuad']}
              style={{minHeight: '850px', marginTop: '60px'}}
            >
              <div className='warp-visit-content-items' key='name'>
                <div className='content-item' style={{padding: '0px', marginTop: '60px'}}>
                  <div className='content-item-block'>
                    <div className='b-title'>
                      人才梯队 | 中层干部 |《跃变·经营管理实战计划》
                    </div>
                  </div>
                </div>
              </div>
              <div className='desc' style={{margin: '24px 0'}}  key='desc'>
                中层管理者是组织战略落地的“承重墙”——他们既要把高层的战略意图翻译为团队能理解、可执行的语言，又要在一线带兵打仗、拿结果。当经营环境从增量扩张转向存量博弈，企业需要的不是只会上传下达的“传声筒”，而是能扛指标、能带队伍、能找增量的“经营合伙人”。我们以经营视角重塑管理认知为核心，围绕高管转型的真实痛点，将中层管理者从“执行者”升级为“经营者”——让每一次管理动作都指向业务结果，让每一个中层都具备高管视野。
              </div>
              <img src={Bg04} alt="" width='1200px' key='img' />
            </QueueAnim>
          </OverPack>
          <OverPack playScale={0.3}>
            <QueueAnim
              key="text"
              type="bottom"
              leaveReverse
              ease={['easeOutQuad', 'easeInQuad']}
              style={{minHeight: '850px', marginTop: '60px'}}
            >
              <div className='warp-visit-content-items' key='name'>
                <div className='content-item' style={{padding: '0px', marginTop: '60px'}}>
                  <div className='content-item-block'>
                    <div className='b-title'>
                      人才梯队 | 基层干部 |《跃升·管理启程计划》
                    </div>
                  </div>
                </div>
              </div>
              <div className='desc' style={{margin: '24px 0'}}  key='desc'>
                基层管理者是战略落地的“最后一公里”——所有高层意图与发展规划，最终都要经由他们转化为一线行动。以前管好自己就行，现在要带好一群人；以前对结果负责就行，现在要对人负责。业务逻辑与管理逻辑之间的断层，是他们每天都要面对的现实。优秀的业务能手，未必天然是合格的管理者。我们只训练“能带队拿结果的人”——聚焦带队伍、拿结果、建标准三项核心任务，以真实管理场景为训练场，以行为改变为检验标准，帮助每一位新经理走好管理生涯的第一步。
              </div>
              <img src={Bg05} alt="" width='1200px' key='img' />
            </QueueAnim>
          </OverPack>
          <OverPack playScale={0.3}>
            <QueueAnim
              key="text"
              type="bottom"
              leaveReverse
              ease={['easeOutQuad', 'easeInQuad']}
              style={{minHeight: '850px', marginTop: '60px'}}
            >
              <div className='warp-visit-content-items' key='name'>
                <div className='content-item' style={{padding: '0px', marginTop: '60px'}}>
                  <div className='content-item-block'>
                    <div className='b-title'>
                      人才梯队 | 新员工 |《初跃·新锐加速计划》
                    </div>
                  </div>
                </div>
              </div>
              <div className='desc' style={{margin: '24px 0'}}  key='desc'>
                Z世代正在成为职场主力军，液态职场时代个体与组织的关系正在被重新定义——新员工不再等待“被培养”，而是期待“被看见、被激活”。我们以“液态职场”趋势与Z世代行为特征为研究起点，从组织与新员工的双向期待出发，将新员工融入期拆解为可预测、可干预的四个阶段。针对每个阶段的高频“职场陷阱”，我们像“驾考宝典”一样提供即刻可用的工具与方法，让新员工在真实任务中理解规则、建立信任、快速输出——将适应期从“自然生长”缩短为“定向加速”。
              </div>
              <img src={Bg06} alt="" width='1200px' key='img' />
            </QueueAnim>
          </OverPack>
          <OverPack playScale={0.3}>
            <QueueAnim
              key="text"
              type="bottom"
              leaveReverse
              ease={['easeOutQuad', 'easeInQuad']}
              style={{minHeight: '850px', marginTop: '60px'}}
            >
              <div style={{color: '#151515', fontSize: '32px', fontWeight: '600'}} key='title'>
                关键岗位.专项赋能
              </div>
              <div className='warp-visit-content-items' key='name'>
                <div className='content-item' style={{padding: '0px', marginTop: '40px'}}>
                  <div className='content-item-block'>
                    <div className='b-title'>
                      专业人才 | 国际化人才 |《企业出海人才培养方案》
                    </div>
                  </div>
                </div>
              </div>
              <div className='desc' style={{margin: '24px 0'}}  key='desc'>
                面对企业出海进程中面临的合规风险难控、跨文化冲突频繁与属地化商业洞察偏弱等核心挑战，本项目致力于帮助组织告别“单兵作战”模式，打造符合出海战略的复合型本土化人才矩阵。项目依托独创的DEEP出海人才胜任力模型为测评与选拔基座，构建了三阶全景培养路径。通过前瞻分析、精准识人、训战结合的闭环设计，全面护航海外阵地的开拓，实现企业全球化业务的高质量落地与长效发展。
              </div>
              <img src={Bg07} alt="" width='1200px' key='img' />
            </QueueAnim>
          </OverPack>
          <OverPack playScale={0.3}>
            <QueueAnim
              key="text"
              type="bottom"
              leaveReverse
              ease={['easeOutQuad', 'easeInQuad']}
              style={{minHeight: '850px', marginTop: '60px'}}
            >
              <div className='warp-visit-content-items' key='name'>
                <div className='content-item' style={{padding: '0px', marginTop: '60px'}}>
                  <div className='content-item-block'>
                    <div className='b-title'>
                      专业人才 | 销售人才 |《大客户销售与解决方案型销售》
                    </div>
                  </div>
                </div>
              </div>
              <div className='desc' style={{margin: '24px 0'}}  key='desc'>
                企业增长已从“流量红利”迈入“专业制胜”与“价值经营”的关键阶段。客户需求碎片化、决策链复杂化、竞争同质化，正成为制约销售团队从“关系驱动”到“专业驱动”的核心瓶颈。本项目以销售实战能力模型为培养基座，围绕“客户洞察、方案设计、商务谈判、客户经营”四大支柱，构建覆盖销售总监、大客户经理及销售骨干的阶梯式销售人才培养体系。通过“精准画像—实战演练—在岗追踪”三阶闭环，帮助销售人员完成从“推销产品”到“经营客户”的认知跃迁，让组织告别单兵作战，以精锐铁军驱动业绩持续增长。
              </div>
              <img src={Bg08} alt="" width='1200px' key='img' />
            </QueueAnim>
          </OverPack>
          <OverPack playScale={0.3}>
            <QueueAnim
              key="text"
              type="bottom"
              leaveReverse
              ease={['easeOutQuad', 'easeInQuad']}
              style={{minHeight: '850px', marginTop: '60px'}}
            >
              <div className='warp-visit-content-items' key='name'>
                <div className='content-item' style={{padding: '0px', marginTop: '60px'}}>
                  <div className='content-item-block'>
                    <div className='b-title'>
                      专业人才 | 供应链与运营人才 |《精益运营与供应链管理》
                    </div>
                  </div>
                </div>
              </div>
              <div className='desc' style={{margin: '24px 0'}}  key='desc'>
                供应链管理已从“成本控制”迈入“韧性构建”与“价值共创”的关键阶段。响应速度慢、协同效率低、风险防控弱，正成为制约供应链从“被动响应”到“主动赋能”的核心瓶颈。本项目以供应链运营能力模型为培养基座，围绕“需求预测、库存优化、供应商协同、风险管控”四大支柱，构建覆盖供应链负责人、采购经理及运营骨干的供应链人才培养体系。通过“理论输入—沙盘推演—实战改善”三阶闭环，帮助供应链人才完成从“管流程”到“经营链条”的认知跃迁，让组织告别粗放运营，以精益能力驱动供应链效能持续释放。
              </div>
              <img src={Bg09} alt="" width='1200px' key='img' />
            </QueueAnim>
          </OverPack>
          <OverPack playScale={0.3}>
            <QueueAnim
              key="text"
              type="bottom"
              leaveReverse
              ease={['easeOutQuad', 'easeInQuad']}
              style={{minHeight: '850px', marginTop: '60px'}}
            >
              <div className='warp-visit-content-items' key='name'>
                <div className='content-item' style={{padding: '0px', marginTop: '60px'}}>
                  <div className='content-item-block'>
                    <div className='b-title'>
                      专业人才 | 《HRBP与组织发展专家实战营》
                    </div>
                  </div>
                </div>
              </div>
              <div className='desc' style={{margin: '24px 0'}}  key='desc'>
                人力资源管理已从“事务执行”迈入“战略伙伴”与“组织赋能”的关键阶段。业务协同难、组织诊断缺位、人才供应链脆弱，正成为制约HR从“成本中心”到“价值中心”的核心瓶颈。本项目以HRBP胜任力模型为培养基座，围绕“业务洞察、组织诊断、人才发展、文化推动”四大支柱，构建覆盖HRBP、OD专家及HR骨干的战略型人力资源管理人才培养体系。通过“理论输入—业务实战—案例复盘”三阶闭环，帮助HR从业者完成从“做人事”到“做业务伙伴”的认知跃迁，让组织告别职能割裂，以人才经营能力驱动组织效能持续提升。
              </div>
              <img src={Bg10} alt="" width='1200px' key='img' />
            </QueueAnim>
          </OverPack>
          <OverPack playScale={0.3}>
            <QueueAnim
              key="text"
              type="bottom"
              leaveReverse
              ease={['easeOutQuad', 'easeInQuad']}
              style={{minHeight: '850px', marginTop: '60px'}}
            >
              <div className='warp-visit-content-items' key='name'>
                <div className='content-item' style={{padding: '0px', marginTop: '60px'}}>
                  <div className='content-item-block'>
                    <div className='b-title'>
                      专业人才 | 内训师 | 《AI·TTT 质效双增：内训师培养与课程开发实战营》
                    </div>
                  </div>
                </div>
              </div>
              <div className='desc' style={{margin: '24px 0'}}  key='desc'>
                企业知识传承已从“经验复制”迈入“AI赋能”与“生态共建”的关键阶段。学用转化率低、个体产能有限、课后陪伴缺失，正成为制约组织学习型生态建设的核心瓶颈。本项目以AI+TTT实战模型为核心引擎，围绕“AI辅助课程开发、智能陪练、即时反馈”三大抓手，构建覆盖内训师团队、业务骨干及培训管理者的师课共建生态。通过“人机协同—实战淬炼—生态共建”三阶闭环，帮助内训师从“学后做”转向“做中学”，大幅压缩从知识输入到成果输出的转化周期，让组织告别低效重复的师课培养模式，以AI驱动的质效双增，推动组织知识资产的高效沉淀与可持续迭代。
              </div>
              <img src={Bg11} alt="" width='1200px' key='img' />
            </QueueAnim>
          </OverPack>
          <OverPack playScale={0.3}>
            <QueueAnim
              key="text"
              type="bottom"
              leaveReverse
              ease={['easeOutQuad', 'easeInQuad']}
              style={{minHeight: '850px', marginTop: '60px'}}
            >
              <div className='warp-visit-content-items' key='name'>
                <div className='content-item' style={{padding: '0px', marginTop: '60px'}}>
                  <div className='content-item-block'>
                    <div className='b-title'>
                      专业人才 | 项目经理 | 《高质量履约与经营管理实战营》
                    </div>
                  </div>
                </div>
              </div>
              <div className='desc' style={{margin: '24px 0'}}  key='desc'>
                项目管理已从“按图施工”迈入“价值经营”与“效能驱动”的关键阶段。进度延期、成本超支、协同不畅，正成为制约项目从“顺利交付”到“经营创效”的核心瓶颈。本项目以项目管理实战模型为培养基座，围绕“进度管控、成本经营、团队协同”三大支柱，构建覆盖项目经理、项目骨干及后备储备人才的复合型项目管理人才培养体系。通过“精准画像—战训融合—在岗追踪”三阶闭环，帮助项目经理完成从“按指令交付”到“经营创效”的认知跃迁，让组织告别粗放推进，以卓越项目管理能力驱动业务高质量落地与可持续增长。
              </div>
              <img src={Bg12} alt="" width='1200px' key='img' />
            </QueueAnim>
          </OverPack>
          <OverPack playScale={0.3}>
            <QueueAnim
              key="text"
              type="bottom"
              leaveReverse
              ease={['easeOutQuad', 'easeInQuad']}
              style={{minHeight: '600px', marginTop: '60px'}}
            >
              <div className='warp-visit-content-items' key='name'>
                <div className='content-item' style={{padding: '0px', marginTop: '60px'}}>
                  <div className='content-item-block'>
                    <div className='b-title'>
                      定制化项目设计新逻辑：始于业务诊断，终于价值验证
                    </div>
                  </div>
                </div>
              </div>
              <img src={Bg13} alt="" width='1200px' key='img' />
            </QueueAnim>
          </OverPack>
        </div>
      </div>
    </div>
  )
}

export default EchelonList